import { Button, PageHeader } from 'components';
import { Form, Row, Col, Divider } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import CompanyForm from 'components/company-form';
import { useCompanies } from '../useCompanies';
import { useEffect } from 'react';
import ShowError from 'components/showError';
import { prepareData } from '../prepareData';

import { useRecoilValue } from 'recoil';
import { getCompanies, getUser } from 'hooks/useUser';
import FormHelper from '../../../../../helpers/FormHelper';

const CompanyCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const user = useRecoilValue(getUser);
  const {
    form,
    prestigeLevels,
    chains,
    companyCategories,
    companyChildCategories,
    singleItem,
    onAction,
    setFormErrors,
    formErrors,
    updateInProcess,
    filtersData,
    setCurrentShppingCenter,
    contractors,
    handleDeleteFile,
    setDeliveryType,
    deliveryType,
    returnType,
    setReturnType,
  } = useCompanies(false);

  const companies = useRecoilValue(getCompanies);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onFinish = (values) => {
    const data = {};
    Object.keys(values).forEach((key) => {
      const [f, s, n, l] = key.split('.');
      if (f === 'company_competitors') {
        data[f] = {
          ...(data[f] || {}),
          [s]: values[key],
        };
        return;
      }
      if (f === 'company_employee_contacts_attributes') {
        data[f] = {
          ...(data[f] || {}),
          [n]: {
            ...(data[f]?.[n] || {}),
            [s]: values[key],
          },
        };
        return;
      }
      if (s === 'company_table_prices') {
        data[s] = {
          ...(data[s] || {}),
          [n]: {
            ...(data[s]?.[n] || {}),
            [l]: values[key],
          },
        };
        return;
      }
      if (s) {
        data[f] = {
          ...(data[f] || {}),
          [s]: values[key],
        };
      } else {
        data[f] = values[key];
      }
    });
    onAction(data);
  };

  const title = isNew ? t('CREARE INSEGNE') : t('MODIFICA INSEGNE');

  const handleCreate = () => {
    form.submit();
  };

  useEffect(() => {
    if (singleItem?.id) {
      setDeliveryType(singleItem?.company_click_collect?.delivery_type);
      setReturnType(singleItem?.company_click_collect?.return_type);
      form.setFieldsValue(prepareData(singleItem));
    }
  }, [singleItem, form]);

  useEffect(() => {
    function logKey(e) {
      if (e.code === 'Enter') {
        // form.submit();
      }
    }
    document.addEventListener('keypress', logKey);
    return () => {
      document.removeEventListener('keypress', logKey);
    };
  }, []);

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <ShowError errors={formErrors} />

        <Form
          name='basic'
          initialValues={{
            title: '',
            shopping_center_id: '',
            nego_id: '',
            vat: '',
            chain_id: '',
            company_category_id: '',
            opening_date: '',
            closing_date: '',
            contract_start_date: '',
            contract_end_date: '',
            place_area: '',
            location_code: '',
            commodity_category: '',
            company_child_category_id: '',
            prestige_level_id: '',
            send_monthly_invoice_reminder: false,
            food: false,
            invoice_year_type: 'half_year',
            'company_data_attributes.phone': '',
            'company_data_attributes.email': '',
            'company_data_attributes.whatsapp': '',
            'company_data_attributes.whatsapp2': '',
            'company_data_attributes.whatsapp3': '',
            'company_data_attributes.address_denominazione': '',
            'company_data_attributes.address_address': '',
            'company_data_attributes.address_city': '',
            'company_data_attributes.address_postal_code': '',
            'company_data_attributes.address_province': '',
            'company_data_attributes.address_tax_code': '',
            'company_data_attributes.address_unique_code': '',
            'company_data_attributes.pec_aziendale': '',
            'company_data_attributes.number_full_time_employees': '',
            'company_data_attributes.number_part_time_employees': '',
            'company_data_attributes.village_contract': false,
            'company_data_attributes.one_day_card': false,
            'company_data_attributes.gift_cards': false,
            'company_data_attributes.tax_free': '',
            'company_data_attributes.payment_mastercard': false,
            'company_data_attributes.payment_visa': false,
            'company_data_attributes.payment_american_express': false,
            'company_data_attributes.payment_alipay': false,
            'company_data_attributes.payment_union_pay': false,
            'company_data_attributes.payment_wechat_pay': false,
            'company_data_attributes.payment_paypal': false,
            'company_data_attributes.payment_apple_pay': false,
            'company_data_attributes.payment_poste_pay': false,
            'company_data_attributes.payment_satispay': false,
            'company_data_attributes.payment_klarna': false,
            'company_data_attributes.payment_scalapay': false,
            'company_data_attributes.payment_accept': false,
            'company_data_attributes.insert_link': '',
            header_image_click_collect: [],
            exclude_reminder_notification: isNew
              ? true
              : singleItem?.exclude_reminder_notification ?? false,
          }}
          form={form}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={(field) => {
            if (
              field &&
              field[0] &&
              field[0].name[0] === 'shopping_center_id'
            ) {
              setCurrentShppingCenter(field[0].value);
            }

            if (
              field &&
              field[0] &&
              field[0].name[0] ===
                'company_click_collect_attributes.delivery_type'
            ) {
              setDeliveryType(field[0].value);
            }

            if (
              field &&
              field[0] &&
              field[0].name[0] ===
                'company_click_collect_attributes.return_type'
            ) {
              setReturnType(field[0].value);
            }

            FormHelper.resetFormsFieldErrors(form)(field);
          }}
        >
          <CompanyForm
            form={form}
            retailOrRoot={isNew ? true : singleItem?.can_full_update}
            isRoot={user?.retail_or_root}
            handleDeleteFile={handleDeleteFile}
            updateInProcess={updateInProcess}
            item={singleItem}
            chains={chains}
            isNew={isNew}
            prestigeLevels={prestigeLevels}
            allCompanies={companies}
            companyCategories={companyCategories}
            companyChildCategories={companyChildCategories}
            filtersData={{ ...filtersData, contractors }}
            deliveryType={deliveryType}
            returnType={returnType}
            siteCategories={singleItem?.company_category?.site_categories || []}
          />
        </Form>
        <Divider />
        <Row gutter={16}>
          <Col>
            <Button
              width={'150px'}
              big
              icon={<CheckOutlined />}
              onClick={handleCreate}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyCategoryEdit;
